import { Model } from 'dva'
import { TelephonyService } from '../../../Service'
import { IsObject } from '../../../Utils/helpers'
import { FailureHandler, ServiceFailureHandler } from 'Utils/ApiHelper'
import { VirtualNumber } from './types'

const VirtualNumbers: Model = {
  namespace: 'virtualNumbers',
  state: {
    list: [],
  },
  effects: {
    *list(
      { useCache = true, setLoading = () => {}, onSuccess = () => {}, onFailure = () => {} },
      { call, put, select }
    ) {
      setLoading(true)
      try {
        let virtualNumbers = yield select((state: any) => state.virtualNumbers.list)
        if (!(virtualNumbers.length > 0 && useCache)) {
          virtualNumbers = yield call(TelephonyService.telephonyVirtualNumbersList, {})
          yield put({ type: 'modifyList', payload: virtualNumbers })
        }
        onSuccess(virtualNumbers)
      } catch (err: any) {
        FailureHandler('Error fetching virtualNumbers', err, onFailure)
      }
      setLoading(false)
    },
    *retrieve(
      {
        number,
        setLoading = () => {},
        onSuccess = () => {},
        onFailure = () => {},
        useCache = false,
      },
      { call, put, select }
    ) {
      setLoading(true)
      try {
        let virtualNumber = null
        if (useCache === true) {
          virtualNumber = yield select((state: any) =>
            state.virtualNumbers.list.find(
              (virtualNumber: VirtualNumber) => virtualNumber.number === number
            )
          )
        }
        if (!virtualNumber) {
          virtualNumber = yield call(TelephonyService.telephonyVirtualNumbersRetrieve, {
            number: number,
          })
        }
        yield put({ type: 'modifyList', payload: virtualNumber })
        onSuccess(virtualNumber)
      } catch (err) {
        FailureHandler('Could not find the virtualNumber in TPS!', err, onFailure)
      }
      setLoading(false)
    },
    *create(
      { data = {}, setLoading = () => {}, onSuccess = () => {}, onFailure = () => {} },
      { call, put }
    ) {
      setLoading(true)
      try {
        const response = yield call(TelephonyService.telephonyVirtualNumbersCreate, {
          requestBody: data,
        })
        yield put({ type: 'modifyList', payload: response })
        onSuccess(response)
      } catch (err) {
        ServiceFailureHandler(err?.body?.error)
      }
      setLoading(false)
    },
    *partialUpdate(
      { number, data, setLoading = () => {}, onSuccess = () => {}, onFailure = () => {} },
      { call, put }
    ) {
      setLoading(true)
      try {
        const response = yield call(TelephonyService.telephonyVirtualNumbersPartialUpdate, {
          number: number,
          requestBody: data,
        })
        yield put({ type: 'modifyList', payload: response })
        onSuccess(response)
      } catch (err) {
        FailureHandler('Error editing a virtualNumber', err, onFailure)
      }
      setLoading(false)
    },
    *destroy(
      { number, setLoading = () => {}, onSuccess = () => {}, onFailure = () => {} },
      { call, put, select }
    ) {
      setLoading(true)
      try {
        yield call(TelephonyService.telephonyVirtualNumbersDestroy, { number: number })
        yield put({ type: 'modifyList', payload: number })
        onSuccess()
      } catch (err) {
        FailureHandler('Error deleting a virtualNumber', err, onFailure)
      }
      setLoading(false)
    },
  },
  reducers: {
    modifyList(state, action) {
      // clone the list
      let list = [...state.list]
      if (IsObject(action.payload)) {
        // if the payload is an object, it's a single object, so add it to the list
        list = list.filter((l: VirtualNumber) => l.number !== action.payload.number)
        list.push(action.payload)
      } else if (Array.isArray(action.payload)) {
        // if the payload is an array, it's a list of objects, so add them to the list
        list = list
          .filter(
            (l: VirtualNumber) =>
              !action.payload.map((p: VirtualNumber) => p.number).includes(l.number)
          )
          .concat(action.payload)
      } else if (Number.isInteger(action.payload)) {
        // if the payload is an integer, it's an number sent in delete operations, so remove it from the list
        list = list.filter((l: VirtualNumber) => l.number !== action.payload)
      } else if (typeof action.payload === 'string') {
        // if the payload is an integer, it's an caller_number sent in delete operations, so remove it from the list
        list = list.filter((l: VirtualNumber) => l.number !== action.payload)
      }
      return {
        ...state,
        list: list,
      }
    },
    resetVirtualNumbers(state, action) {
      return {
        ...state,
        list: [],
      }
    },
  },
}

export default VirtualNumbers
